export default "/app/themes/macleod/public/images/scroll-down-icon.svg?34a1a70b5739e70575ac549ffeb12a61";